// extracted by mini-css-extract-plugin
module.exports = {"information":"iTEMm3I8","title":"VjJKlaAO","description":"alV_SF_B","referensi":"CIqL63cP","link":"GOExC9Qo","videoTitle":"_sVDmNiA","card":"DrgKuumb"};